import get from 'lodash.get';
import { AppState } from 'services/types';
import { selectWorksheet } from 'services/worksheet/selectors';
import {
    FertilizerWorksheetComments,
    WorksheetPageIndex
} from 'services/worksheet/types';
import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';
import { Props } from './index';

const selectPageIndex = (_state: AppState, props: Props): WorksheetPageIndex =>
    props.pageIndex;

const selectFertilizerWorksheetEntityComments = createDeepEqualSelector(
    selectWorksheet,
    selectPageIndex,
    (worksheetState, index) =>
        get(worksheetState, [
            'pages',
            index,
            'comments'
        ]) as FertilizerWorksheetComments
);

const makeSelectFertilizerWorksheetComments =
    (): typeof selectFertilizerWorksheetEntityComments =>
        selectFertilizerWorksheetEntityComments;

export { selectPageIndex, makeSelectFertilizerWorksheetComments };
